<div class="events-with-filters">
  <div class="container container-boxed">

    <div class="events-with-filters--header">
      <div class="event-filters">
        <div class="event-filters--season">
          <ngx-slick-carousel #yearsSlider class="carousel season-picker" [config]="yearsSlideConfig">
            <label ngxSlickItem *ngFor="let year of widget.data.years">
              <input [checked]="year === selectedYear" name="season" type="radio" [value]="year">
              <span (click)="onClickYearFilter(year)">{{ year }}</span>
            </label>
          </ngx-slick-carousel>
        </div>

        <div class="event-filters--view-mode">
          <h5>Ansicht:</h5>
          <div class="view-mode-picker">
            <label>
              <input [checked]="viewMode === 'list'" type="radio" value="list" name="view-mode" (click)="setViewMode('list')">
              <span>
                <img title="Listenansicht" src="assets/images/icons/icon-list.svg" alt="Listenansicht">
              </span>
            </label>
            <label>
              <input [checked]="viewMode === 'grid'" value="grid" type="radio" name="view-mode" (click)="setViewMode('grid')">
              <span>
                <img title="Kachelansicht" src="assets/images/icons/icon-grid.svg" alt="Kachelansicht">
              </span>
            </label>
          </div>
        </div>
      </div>

      <div class="event-filters--day-picker" *ngIf="eventDates">
        <div class="event-days">
          <ngx-slick-carousel #datesSlider class="carousel" [config]="slideConfig">
            <ng-container *ngFor="let day of eventDates; let i = index; trackBy: trackByFn">
              <div ngxSlickItem class="event-day" [class.selected]="day === selectedDay" (click)="onClickEventDay(day)">
                <div class="event-day--content">
                  <span>{{ day | date:'EEE' }}</span>
                  <time>{{ day | date:'dd.MM.' }}</time>
                </div>
              </div>
            </ng-container>
          </ngx-slick-carousel>
        </div>
      </div>

      <div class="event-filters--categories">
        <h1>Kalender</h1>
        <h4>Filter:</h4>
        <div *ngIf="categories" class="event-filters--categories-list">
          <a *ngFor="let category of categories"
             (click)="onClickCategoryFilter(category)"
             [class.active]="category.selected"
             [ngClass]="getCategoryButtonClasses(category.category)"
             class="button button-event-category">
            {{ category.category.name }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="events-list-container">
    <div class="container container-boxed">
      <div class="events-list" *ngIf="events" [class.list-view]="viewMode === 'list'"
           [class.grid-view]="viewMode === 'grid'">
        <ng-container *ngFor="let event of events">
          <article *ngIf="filterBySelectedDate(event)" [ngClass]="getEventStyle(event)">
            <div class="event-image">
              <div class="image-holder" [title]="getEventCopyrights(event)">
                <div class="image-holder-content">
                  <app-webp-image
                    *ngIf="event.image"
                    [src]="getEventImageUrl(event)"
                    [blurhash]="event.imageBlurHash"
                    [alt]="event.name"
                    [blurWidth]="32"
                    [blurHeight]="32"
                  ></app-webp-image>
                </div>
              </div>
              <div class="event-meta">
                <div class="event-date">{{ event.startTime | date:'EEEE, dd. MMMM | HH.mm' }} Uhr</div>
              </div>
            </div>
            <div class="event-content">
              <h3>
                <a [routerLink]="['/', 'event', event.slug]">
                  {{ getEventDisplayName(event) }}
                </a>
              </h3>
              <p>
                <strong [innerHtml]="event.subtitle"></strong>
              </p>
              <div class="event-date">{{ event.startTime | date:'EEEE, dd. MMMM | HH.mm' }} Uhr</div>
              <p class="event-artists" [innerHtml]="getEventArtists(event)"></p>
              <p>{{ event.location }}</p>
            </div>
            <div class="event-buttons" *ngIf="event.slug">
              <div *ngIf="event.slug">
                <a [routerLink]="['/', 'event', event.slug]" class="button button-white">Details</a>
              </div>
              <div *ngIf="event.ticketUrl || event.externalId">
                <a *ngIf="event.externalId" class="MyEventButton no-external-link-icon button button-default" [attr.eid]="event.externalId" [attr.edid]="event.startTime" [attr.siteid]="'1AC0E12D-B0DA-4047-8A09-EEC91977AC62'">Karten
                  kaufen</a>
                <a *ngIf="!event.externalId" target="_blank" [href]="event.ticketUrl" class="no-external-link-icon button button-default">Karten kaufen</a>
              </div>
            </div>
          </article>
        </ng-container>
      </div>
    </div>
  </div>
</div>
